/* eslint-disable */
import HttpService from '../HttpService';
export default class BenefitService {
  constructor() {
    this._httpService = new HttpService('/contract/benefit');
  }

  async FindAll(financialGroupIds = null) {
    const params = financialGroupIds
      ? `?financialGroups=${financialGroupIds}`
      : ''
    const serviceUrl = `/find-by-permission${params}`;
    return await this._httpService.get(serviceUrl);
  }
};
